import { Input, Label } from 'src/componentes/Form';
import Button from 'src/componentes/button';
import Dialog from 'src/componentes/dialog';
import { Container } from 'reactstrap';
import { useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import ContentManager from 'src/componentes/content-manager';
import Alert from 'src/componentes/message-box/alert';
import http from 'src/services/httpService';
import { useSnackbar } from 'notistack';
import errorHandler from 'src/utils/errorHandler';

export default function ConfirmacaoDevolutiva({
  modelPerdaOperacional = {},
  handleClose = () => {},
  handleRefresh = () => {},
  endpoint = '/PerdaOperacional',
  resources,
  ...rest
}) {
  const intl = useIntl();
  const ref = useRef();
  const { enqueueSnackbar } = useSnackbar();
  const [errorRequired, setErrorRequired] = useState(false);
  const [model, setModel] = useState({
    ...modelPerdaOperacional,
    justificativaDevolucao: '',
  });

  const handleChange = (value) => {
    setModel({ ...model, justificativaDevolucao: value });
  };

  const handleCloseClick = () => {
    if (ref.current) ref.current.close();

    handleClose && handleClose();
  };

  const handleSaveClick = async () => {
    if (model.justificativaDevolucao) {
      setErrorRequired(false);
      try {
        await http
          .post(`${endpoint}/DevolverAnalise`, {
            model: model,
          })
          .then(() => {
            enqueueSnackbar(
              intl.formatMessage({ id: 'labelRegistroDevolvidoComSucesso' }),
              { variant: 'success' }
            );
            handleRefresh();
            handleCloseClick(true);
          });
      } catch (err) {
        errorHandler(err);
      }
    } else {
      ContentManager.addContent(
        <Alert
          message={intl.formatMessage({
            id: 'label.osCamposDestacadosEmVermelhoSaoObrigatoriosFavorPreenchelos',
          })}
        />
      );
      setErrorRequired(true);
    }
  };

  const actions = [
    <Button key={1} onClick={handleCloseClick} color="primary">
      {intl.formatMessage({ id: 'label.cancelar' })}
    </Button>,
    <Button key={2} className="ml-2" color="primary" onClick={handleSaveClick}>
      {intl.formatMessage({ id: 'labelDevolver' })}
    </Button>,
  ];

  return (
    <Dialog
      title={intl.formatMessage(
        { id: 'titleModalDevolucaoPerdaOperacional' },
        {
          perdaoperacional: resources.perdaoperacional,
          nomedaperdaoperacional: modelPerdaOperacional?.nome,
        }
      )}
      actions={actions}
      width={500}
      minHeight={290}
      onRequestClose={handleCloseClick}
      mouseDownClose={false}
      ref={ref}
      {...rest}
    >
      <Container>
        <div className="pt-3">
          <div
            style={{
              fontSize: '14px',
              fontFamily: 'nunito',
              lineHeight: '21.82px',
            }}
          >
            {intl.formatMessage(
              { id: 'msgDevolucaoPerdaOperacional' },
              { perdaoperacional: resources.perdaoperacional }
            )}
          </div>
          <div>
            <div className="pt-3">
              <Label
                className="p-0 pb-2 m-0"
                style={{
                  fontSize: '14px',
                  fontFamily: 'nunito',
                  lineHeight: '21.82px',
                  color: errorRequired ? '#FF0000' : '',
                }}
              >
                {intl.formatMessage({
                  id: 'labelJustificativaConfirmacaoDevolucao',
                })}
                {' *'}
              </Label>
              <Input
                required={true}
                type="textarea"
                rows={'4'}
                value={model.justificativaDevolucao}
                onChange={(value) => handleChange(value.currentTarget.value)}
                errors={errorRequired}
                maxLength={30000}
              />
            </div>
          </div>
        </div>
      </Container>
    </Dialog>
  );
}
